if (!customElements.get('custom-video-player')) {
  customElements.define('custom-video-player', class CustomVideoPlayer extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector('video');
      this.playBtn = this.querySelector('.custom-video-play-btn');
      this.muteBtn = this.querySelector('.custom-video-mute-btn');
      this.muteOnIcon = this.querySelector('.mute-on');
      this.muteOffIcon = this.querySelector('.mute-off');
    }

    connectedCallback() {
      if (!this.video) return;

      this.addEventListener('click', () => {
        this.togglePlay();
      });

      if (this.playBtn) {
        this.playBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.togglePlay();
        });
      }

      if (this.muteBtn) {
        this.muteBtn.addEventListener('click', (e) => {
          e.stopPropagation();
          this.toggleMute();
        });
      }

      this.video.addEventListener('play', () => this.classList.add('video-playing'));
      this.video.addEventListener('pause', () => this.classList.remove('video-playing'));
      this.video.addEventListener('ended', () => this.classList.remove('video-playing'));

      this.ensureAutoplay();
    }

    ensureAutoplay() {
      if (this.video.hasAttribute('autoplay')) {
        this.video.muted = true;
        this.video.setAttribute('playsinline', '');

        const playPromise = this.video.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => this.classList.add('video-playing'))
            .catch(() => this.classList.remove('video-playing'));
        }
      } else if (!this.video.paused) {
        this.classList.add('video-playing');
      }
    }

    togglePlay() {
      if (this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }

    toggleMute() {
      this.video.muted = !this.video.muted;
      if (this.video.muted) {
        if (this.muteOnIcon) this.muteOnIcon.classList.add('hidden');
        if (this.muteOffIcon) this.muteOffIcon.classList.remove('hidden');
      } else {
        if (this.muteOnIcon) this.muteOnIcon.classList.remove('hidden');
        if (this.muteOffIcon) this.muteOffIcon.classList.add('hidden');
      }
    }
  });
}
